"use strict";
var header = document.querySelector('header.sticky');
var menu_toggle = document.getElementById('menu-toggle');
var menu_wrapper = document.getElementById('menu-wrapper');
var submenu_toggle = document.querySelectorAll('#menu-wrapper .menu li.menu-item-has-children > a');
menu_toggle.addEventListener('click', function () {
    document.body.classList.toggle('menu-open');
    menu_wrapper.classList.toggle('menu-open');
});
var inner_width = window.innerWidth;
if (inner_width < '1280') {
    submenu_toggle.forEach(function (submenu) {
        submenu.addEventListener('click', function (e) {
            e.preventDefault();
            submenu.classList.toggle('open');
            submenu.parentElement.lastElementChild.classList.toggle('open');
        });
    });
}
if (inner_width >= '1536') {
    window.addEventListener("scroll", function () {
        if (window.scrollY >= 49) {
            header.classList.add('stuck');
        }
        else {
            header.classList.remove('stuck');
        }
    });
}
